<template>
  <div>
    <b-modal
      :title="`${number}已繳費細項`"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <tables-page
        :tableData="data.table_data"
        :tableFields="data.table_fields"
        v-on:result="getBillFlatten"
      >
        <template #cell(no)="row">
          {{ countNoNum(data.page, row.index) }}
        </template>

        <template #cell(type)="row">
          <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
        </template>

        <template #cell(dead_line)="row">
          {{ convertRocDate(row.item.dead_line, false) }}
        </template>

        <template #cell(payment_at)="row">
          {{ convertRocDate(row.item.payment_at, false) }}
        </template>

        <template #cell(bill_updated_at)="row">
          {{ convertRocDate(row.item.bill_updated_at, false) }}
        </template>
      </tables-page>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import { countNoNum, convertRocDate, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'PaidDetailsModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    number: {
      type: String,
      required: true
    }
  },
  components: {
    TablesPage
  },
  data () {
    return {
      status: {
        resetDom: false,
        isLoading: false
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "period",
            label: "帳單期別"
          },
          {
            key: "type",
            label: "類別"
          },
          {
            key: "amount",
            label: "互助金"
          },
          {
            key: "dead_line",
            label: "繳款期限",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳費來源"
          },
          {
            key: "sales_number",
            label: "業務編號"
          },
          {
            key: "sales_name",
            label: "業務姓名"
          },
          {
            key: "bill_updated_at",
            label: "異動時間"
          }
        ],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
        temp_table_data: {}
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loda();
          this.getBillFlatten();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
  },
  methods: {
    countNoNum,
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    // 首次載入讀取
    loda() {
      this.data.page = Object.assign({}, this.billApi.page);
    },
    // 查詢帳單
    getBillFlatten(sortBy = '', sort = '') {
      this.status.isLoading = true;

      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        'number': this.number,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort,
        'class': 0,
        'PageSize': 99999,
        'PageIndex': 1,
      };
      this.billApi.getBillFlatten((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;

        this.status.isLoading = false;
      }, params, false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Modal/PaidDetailsModal.vue